<template>
  <section>
    <TitleBar>Situation de capital social</TitleBar>
    <b-container fluid>
      <ErrorComponent :error="error" @hide="error = null"></ErrorComponent>
      <StrapiEditoComponent></StrapiEditoComponent>
      <template v-if="fichiers == null">
        <div class="text-center text-warning my-3">
          <b-spinner class="align-middle"></b-spinner>
          <br />
          <strong>Chargement en cours...</strong>
        </div>
      </template>
      <template v-else-if="fichiers.length === 0">
        <BubbleComponent>
          <p>
            <strong>
              Vous n'avez aucun &eacute;tat de capital social disponible.
            </strong>
          </p>
          <p>Plusieurs explications sont possibles :</p>
          <ul>
            <li>
              Vous n'&ecirc;tes pas correctement identifi&eacute; comme
              adh&eacute;rent dans notre syst&egrave;me d'information, ou votre
              date d'adh&eacute;sion est manquante
            </li>
            <li>
              Vous n'avez pas r&eacute;pondu &agrave; l'appel de capital social
              suite &agrave; votre r&eacute;cente adh&eacute;sion, et n'en avez
              donc pas actuellement
            </li>
            <li>
              Votre coop&eacute;rative n'a pas encore effectu&eacute; la
              1&egrave;re &eacute;dition
            </li>
          </ul>
          <p>
            <em>
              Si vous pensez qu'il y a erreur, vous pouvez bien entendu toujours
              contacter votre coop&eacute;rative !
            </em>
          </p>
        </BubbleComponent>
      </template>
      <template v-else-if="affichageMobile">
        <RecapitulatifCapsocCard
          v-for="item in fichiers"
          :key="`fichier-${item.idFichier}`"
          :item="item"
        ></RecapitulatifCapsocCard>
      </template>
      <template v-else>
        <b-row>
          <b-col cols="12" md="4" lg="3">
            <strong>Date de valeur</strong>
          </b-col>
          <b-col cols="12" md="4" lg="3">
            <strong>Document</strong>
          </b-col>
        </b-row>
        <b-row v-for="item in fichiers" :key="`fichier-${item.idFichier}`">
          <b-col cols="12" md="4" lg="3">
            {{ item.dateValeur }}
          </b-col>
          <b-col cols="12" md="4" lg="3">
            <DownloadComponent
              :typeDocument="typeDocument"
              :targetId="item.idFichier"
            ></DownloadComponent>
          </b-col>
        </b-row>
      </template>
    </b-container>
  </section>
</template>

<script>
import TitleBar from "../../components/TitleBar.vue";
import ErrorComponent from "../../components/ErrorComponent.vue";
import StrapiEditoComponent from "../../components/strapi/StrapiEditoComponent.vue";
import BubbleComponent from "../../components/BubbleComponent.vue";
import RecapitulatifCapsocCard from "../../components/cards/RecapitulatifCapsocCard.vue";
import DownloadComponent from "../../components/controls/DownloadComponent.vue";
import ExploitationService from "../../services/exploitation.service";
import UtilsService, { SortDirection } from "../../services/utils.service";
export default {
  name: "SituationCapsocView",
  components: {
    TitleBar,
    ErrorComponent,
    StrapiEditoComponent,
    BubbleComponent,
    RecapitulatifCapsocCard,
    DownloadComponent,
  },
  data() {
    return {
      typeDocument: this.$store.state.expl.typesDocument.RECAP_CAPSOC,
      error: null,
      fichiers: null,
    };
  },
  computed: {
    exploitationCourante() {
      return this.$store.getters["expl/adherentCourant"];
    },
    affichageMobile() {
      return this.$store.getters["affichageMobile"];
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.error = null;
      try {
        let response = await ExploitationService.getRecapitulatifsCapsoc(
          this.exploitationCourante.codeTiers
        );
        this.fichiers = response.data
          .map((f) => {
            let dateEdition = f.cheminFichier.split("_")[2];
            f.dateValeur =
              dateEdition.slice(6, 8) +
              "/" +
              dateEdition.slice(4, 6) +
              "/" +
              dateEdition.slice(0, 4);
            return f;
          })
          .sort(
            UtilsService.sortByStringProperty(
              "cheminFichier",
              SortDirection.DESC
            )
          );
      } catch (error) {
        this.error = UtilsService.handleError(error);
      }
    },
  },
};
</script>
